var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcPedidoRetirada = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:none;stroke:#2ABA83;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#2ABA83;}\r\n\t.st2{fill:#D4145A;}\r\n\t.st3{fill:#363636;}\r\n\t.st4{display:none;}\r\n\t.st5{display:inline;}\r\n\t.st6{fill:#30323A;}\r\n\t.st7{font-family:'Poppins-Regular';}\r\n\t.st8{font-size:3.9346px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bolsas_e_Olheiras"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Hidratante"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Repelente"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guias"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Barba"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Calv\\xEDcie"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Clareador"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Beleza"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Iluminador"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Preechedor"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Crescimento_Capilar"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Pesco\\xE7o_e_Colo"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Fortalecedor_de_Cabelo"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Sa\\xFAde"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Fortalecedor_de_Unha"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Protetor_Solar"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Texto"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.5,15.18c-0.28,0-0.5,0.22-0.5,0.5v3.35c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5v-3.35 C41,15.41,40.78,15.18,40.5,15.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.93,21.84h-3.56c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h3.56c0.28,0,0.5-0.22,0.5-0.5 S52.21,21.84,51.93,21.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.36,21.84H29.8c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h3.56c0.28,0,0.5-0.22,0.5-0.5 S33.64,21.84,33.36,21.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.22,16.32c-0.19-0.2-0.51-0.21-0.71-0.02L45,18.67c-0.2,0.19-0.21,0.51-0.02,0.71 c0.1,0.1,0.23,0.16,0.36,0.16c0.12,0,0.25-0.04,0.34-0.14l2.51-2.37C48.4,16.84,48.41,16.52,48.22,16.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.7,16.3c-0.2-0.19-0.52-0.18-0.71,0.02c-0.19,0.2-0.18,0.52,0.02,0.71l2.52,2.37 c0.1,0.09,0.22,0.14,0.34,0.14c0.13,0,0.27-0.05,0.36-0.16c0.19-0.2,0.18-0.52-0.02-0.71L33.7,16.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.38,31.56c0-1.32-1.12-2.39-2.5-2.39h-3.71v-7.36c0-0.28-0.22-0.5-0.5-0.5h-2.65h-3.03h-2.65c-0.28,0-0.5,0.22-0.5,0.5 v7.36h-6.26c-0.16-1.64-1.51-2.95-3.23-3.12V25.3c0-1.58-1.02-2.93-2.47-3.5c1.43-0.6,2.43-1.96,2.43-3.54 c0-2.14-1.83-3.88-4.08-3.88s-4.08,1.74-4.08,3.88c0,1.58,1,2.93,2.43,3.54c-1.45,0.57-2.47,1.93-2.47,3.5v3.87H15.2 c-1.38,0-2.5,1.07-2.5,2.39c0,1.12,0.81,2.05,1.89,2.31v14.36c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5V33.95h23.98 c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5H15.2c-0.83,0-1.5-0.62-1.5-1.39c0-0.76,0.67-1.39,1.5-1.39h21.14h8.33h4.21 c0.83,0,1.5,0.62,1.5,1.39c0,0.76-0.67,1.39-1.5,1.39h-6.86c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h6.41v14.28 c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5V33.88C50.54,33.65,51.38,32.7,51.38,31.56z M19.14,18.26c0-1.59,1.38-2.88,3.08-2.88 s3.08,1.29,3.08,2.88c0,1.59-1.38,2.88-3.08,2.88S19.14,19.84,19.14,18.26z M19.1,29.17V25.3c0-1.54,1.34-2.8,3-2.8h0.25 c1.65,0,3,1.25,3,2.8v0.71h-2.62v-1.9c0-0.28-0.22-0.5-0.5-0.5s-0.5,0.22-0.5,0.5v2.4c0,0.28,0.22,0.5,0.5,0.5h3.74 c1.35,0,2.45,0.95,2.62,2.16H19.1z M39.49,22.32h2.03v3.56h-2.03V22.32z M44.17,29.17h-7.33v-6.86h1.65v4.06 c0,0.28,0.22,0.5,0.5,0.5h3.03c0.28,0,0.5-0.22,0.5-0.5v-4.06h1.65V29.17z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "label",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1.6094 58.6176)",
    className: "st6 st7 st8"
  }, "PEDIDO PRONTO PARA RETIRADA"))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcPedidoRetirada, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-pedido-retirada.af65e96d.svg";
export { ForwardRef as ReactComponent };